import { Screen } from 'components/screen';
import forgotPasswordScreenHTML = require('html-loader!html/forgot-password-screen');

export class ForgotPasswordScreen extends Screen {
  public static readonly screenID: string = 'forgot-password';

  public async renderImpl(): Promise<void> {
    this.containerEl.innerHTML = forgotPasswordScreenHTML;
    await this.showCaptchaWidget();
  }

  public async submitImpl(): Promise<void> {
    await this.marinSSO.forgotPassword({
      loginID: this.getFormValue('loginID'),
      siteID: this.marinSSO.siteID,
    });
  }

  protected getTitle() {
    return 'Forgot Password';
  }

  protected shouldRenderCaptcha(): boolean {
    return true;
  }
}
